const state = {
  programDialog: null,
  clientDialog: null,
  staffDialog: null,
  eventDialog: null,
  addEventDialog: null,
};

const getters = {};

const actions = {};

const mutations = {
  SET_PROGRAM_DIALOG(state, data) {
    state.programDialog = data;
  },
  SET_CLIENT_DIALOG(state, data) {
    state.clientDialog = data;
  },
  SET_STAFF_DIALOG(state, data) {
    state.staffDialog = data;
  },
  SET_EVENT_DIALOG(state, data) {
    state.eventDialog = data;
  },
  SET_ADD_EVENT_DIALOG(state, data) {
    state.addEventDialog = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
